import Quill from 'quill';
import { sanitizeHtml } from '@utils/sanitize';

// Quill parses stored HTML by assigning it to a live container's innerHTML,
// so an <img onerror> in saved content fires as soon as an editor loads it.
export function registerSafeQuillClipboard() {
  const Clipboard = Quill.import('modules/clipboard');

  class SafeClipboard extends Clipboard {
    convert(html) {
      return super.convert(typeof html === 'string' ? sanitizeHtml(html) : html);
    }
  }

  Quill.register('modules/clipboard', SafeClipboard, true);
}
